module.exports = __webpack_public_path__ + "img/dsci0135.4780928a.jpg";